import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  FormGroup,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { CircularProgress } from "@mui/material";

import {
  Grid,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Box,
  FormLabel,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  TableContainer,
  Table,
  InputLabel,
  Checkbox,
  ListItemText,
} from "@mui/material";
import style from "../../components/RFPDashboard/CampaignDetails/Campaign.module.css";
import CustomInput from "../../shared/utils/Input";

import "./vendorOnboard.css";
import { Close, Delete } from "@mui/icons-material";
import { PlusIcon } from "../assets/icons";

const PrintingMachineNeeded = ({
  errors,
  handlePrintMachineSelection,
  printMachine,
  selectedPrintMachines,
  scopeOfWork,
  otherSelectedIndexes,
  setOtherSelectedIndexes,
  handleInputChange,
  handleDeleteMachineSelection,
  index,
  brandNames,
  width,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const MachineModalOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="border  rounded-lg pb-2 mb-3">
      <div className="flex justify-between items-center py-3 w-full bg-[#e0edf4] px-3 rounded-t-lg">
        <div>
          <h1>Printing Machine Required</h1>
        </div>
        <button
          className="btn flex items-center gap-2 rounded-lg shadow-lg text-white px-4 py-2 bg-[var(--primary-color)]"
          onClick={() => MachineModalOpen()}
        >
          <PlusIcon color="white" size="14px" /> Add Machine
        </button>

        {
          <Modal open={isOpen} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400, // Adjust width as needed
                bgcolor: "white", // Background color
                boxShadow: 24, // Adds shadow
                borderRadius: "8px", // Rounded corners
              }}
            >
              <div className="border w-full flex justify-between items-center bg-blue-400  p-3 rounded-lg">
                <Typography variant="h6" component="h2" sx={{ color: "white" }}>
                  Select Machines
                </Typography>
                <IconButton onClick={handleClose} sx={{ color: "white" }}>
                  <Close />
                </IconButton>
              </div>
              <FormControl
                fullWidth
                sx={{
                  marginTop: "0.5rem",
                  marginBottom: "7px",
                  borderRadius: 2,
                  padding: "16px",
                }}
              >
                <FormGroup>
                  {printMachine.map((machine, i) => (
                    <FormControlLabel
                      key={i}
                      control={
                        <Checkbox
                          checked={selectedPrintMachines.includes(machine.type)}
                          onChange={() =>
                            handlePrintMachineSelection(machine.type)
                          }
                        />
                      }
                      label={<span className="">{machine.type}</span>}
                    />
                  ))}
                </FormGroup>
              </FormControl>
            </Box>
          </Modal>
        }
      </div>

      {/* machines list */}
      <div className=" flex flex-col mx-4 ">
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2"> */}
        {selectedPrintMachines.map((selectedType, i) => {
          const machine = scopeOfWork.machinesNeededForPrinting.find(
            (m) => m.type === selectedType
          );

          if (machine) {
            return (
              <div
                key={i}
                className="mt-4 shadow-md rounded-lg px-10 py-2 border"
              >
                <div className="flex items-center justify-between ">
                  <label className="font-semibold">{`${machine.type} `}</label>

                  <IconButton
                    onClick={() => handleDeleteMachineSelection(machine.type)}
                  >
                    <Delete sx={{ color: "var(--error-color)" }} />
                  </IconButton>
                </div>
                <div className="border w-full  my-1 rounded-lg" />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                  <FormControl fullWidth size="small">
                    <label className="mb-2 text-[var(--para-color)]">{`Type of Printer Head`}</label>
                    <Select
                      name={`machinesNeededForPrinting-details-${machine.type}-machinePrintingSubType-${index}`}
                      value={machine.details.machinePrintingSubType || ""}
                      onChange={(e) => {
                        handleInputChange(e, index);
                      }}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span className="text-[var(--listdown-color)]">
                              {`Select Printing Sub Type:`}
                            </span>
                          );
                        }
                        return selected;
                      }}
                      inputProps={{
                        "aria-label": "Select Machine Age",
                      }}
                    >
                      <MenuItem value="Roll 2 Roll">Roll 2 Roll</MenuItem>
                      <MenuItem value="FlatBed">Flat Bed</MenuItem>
                      <MenuItem value="Hybrid">Hybrid</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth size="small">
                    <label className="mb-2 text-[var(--para-color)]">{`Brand`}</label>
                    {otherSelectedIndexes?.includes(i) ? (
                      // Textbox if "Other" is selected
                      <CustomInput
                        name={`machinesNeededForPrinting-details-${machine.type}-machineBrand-${index}`}
                        placeholder="Enter Brand Name"
                        type="text"
                        size="small"
                        onChange={(e) => {
                          handleInputChange(e, index);
                        }}
                        value={machine.details.machineBrand || ""}
                        className="mt-2"
                      />
                    ) : (
                      <Select
                        inputProps={{
                          "aria-label": "Without label",
                        }}
                        displayEmpty
                        name={`machinesNeededForPrinting-details-${machine.type}-machineBrand-${index}`}
                        value={machine.details.machineBrand || ""}
                        // onChange={(e) => {
                        //   handleInputChange(e, index);
                        // }}
                        onChange={(e) => {
                          handleInputChange(e, index);
                          if (e.target.value === "Other") {
                            setOtherSelectedIndexes((prev) => [...prev, i]);
                          } else {
                            setOtherSelectedIndexes((prev) =>
                              prev.filter((index) => index !== i)
                            );
                          }
                        }}
                        renderValue={(selected) => {
                          if (!selected || selected.length === 0) {
                            return (
                              <p className="text-[1rem] text-[var(--listdown-color)]">
                                Select Brand
                              </p>
                            );
                          }
                          return (
                            <span style={{ color: "#000" }}>{selected}</span>
                          );
                        }}
                      >
                        {brandNames
                          ?.find(
                            (brandGroup) => brandGroup.value === machine.type
                          )
                          ?.brandNames.map((brand, i) => (
                            <MenuItem value={brand} key={i}>
                              <Radio
                                checked={machine.details.machineBrand === brand}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    handleInputChange(
                                      {
                                        target: {
                                          name: `machinesNeededForPrinting-details-${machine.type}-machineBrand-${index}`,
                                          value: brand,
                                        },
                                      },
                                      index
                                    );
                                  }
                                }}
                                style={{ paddingRight: "8px" }}
                              />
                              {brand}
                            </MenuItem>
                          ))}
                        <MenuItem value="Other">
                          <Radio
                            checked={machine.details.machineBrand === "Other"}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setOtherSelectedIndexes((prev) => [...prev, i]);
                                handleInputChange(
                                  {
                                    target: {
                                      name: `machinesNeededForPrinting-details-${machine.type}-machineBrand-${index}`,
                                      value: "Other",
                                    },
                                  },
                                  index
                                );
                              }
                            }}
                            style={{ paddingRight: "8px" }}
                          />
                          Other
                        </MenuItem>
                      </Select>
                    )}
                  </FormControl>

                  {machine?.type !== "Plotter Cutting Printing" &&
                    machine?.type !== "UV Printing" &&
                    machine?.type !== "Latex Printing" && (
                      <FormControl fullWidth size="small">
                        <label className="mb-2 text-[var(--para-color)]">{`Picoliter`}</label>
                        <TextField
                          select
                          size="small"
                          fullWidth
                          name={`machinesNeededForPrinting-details-${machine.type}-picoliter-${index}`}
                          value={machine.details.picoliter || ""}
                          onChange={(e) => handleInputChange(e, index)}
                        >
                          {[
                            1.2,
                            1.5,
                            2.5,
                            3.5,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            ...Array.from({ length: 25 }, (_, i) => i + 11),
                          ].map((num) => (
                            <MenuItem key={num} value={num}>
                              {num}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    )}

                  <div className="flex flex-col gap-2">
                    <label className=" text-[var(--para-color)]">{`Machine Width (Ft.)`}</label>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      name={`machinesNeededForPrinting-details-${machine.type}-maxPrintSize-${index}`}
                      value={machine?.details?.maxPrintSize || ""}
                      onChange={(e) => {
                        handleInputChange(e, index);
                      }}
                      required
                    >
                      {width[machine.type]?.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ marginBottom: "7px" }}
                  >
                    <label className=" text-[var(--para-color)]">{`Machine Age`}</label>
                    <Select
                      name={`machinesNeededForPrinting-details-${machine.type}-ageOfMachine-${index}`}
                      value={machine.details.ageOfMachine || ""}
                      onChange={(e) => {
                        handleInputChange(e, index);
                      }}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span className="text-[var(--listdown-color)]">
                              Select Age
                            </span>
                          );
                        }
                        return selected;
                      }}
                      inputProps={{
                        "aria-label": "Select Machine Age",
                      }}
                      sx={{ marginTop: "0.5rem" }}
                    >
                      <MenuItem value="0-4">0 to 4 years</MenuItem>
                      <MenuItem value="4+">4 years and above</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            );
          }

          return null;
        })}
        <div className="border w-full my-4" />
      </div>
      <div className=" flex flex-col">
        {errors?.machinesNeededForPrinting && (
          <p className="text-[var(--error-color)] text-[12px] ml-3">
            {errors.machinesNeededForPrinting}
          </p>
        )}
      </div>
    </div>
  );
};

export default PrintingMachineNeeded;
